module.exports = __webpack_public_path__ + "img/zoom-out.77cb9144.svg";